// аплаить стили через тег <style> производительнее, чет setProperty
export function createVariablesStyleTag(selector, variables, nonce) {
    const styleTag = document.createElement('style');
    styleTag.setAttribute('type', 'text/css');
    nonce && styleTag.setAttribute('nonce', nonce);
    const variablesText = Object.entries(variables).reduce((result, [key, value]) => result + `${key}: ${value};`, '');
    styleTag.append(`${selector} {${variablesText}}`);
    return styleTag;
}
export function collectPath(val, paths, result) {
    if (typeof val === 'undefined' || typeof val === 'boolean') {
        return;
    }
    if (typeof val !== 'object') {
        result[`--${paths.join('-')}`] = typeof val !== 'string' ? `${val}px` : val;
        return;
    }
    for (let key in val) {
        collectPath(val[key], [...paths, key], result);
    }
}
export function getVariables(theme) {
    const result = {};
    collectPath(theme, [], result);
    return result;
}
